<template>
  <div>
 <HeaderBreadcrumbs
      :items="[
        { label: 'SmartPin', to: { name: 'smart-pin' } },
           { label: 'SmartPin Detail' },
      ]"
      title="Access Location"
    />   
    <div class="flex justify-between items-center space-x-4">
        <div class="bg-white shadow-sm rounded-lg h-80 p-4 w-full">
                <div class="flex justify-between items-center">
                    <div>
                        <label class="font-bold text-lg leading-5">Detail</label>
                    </div>
                    <div class="flex justify-center items-center space-x-4">
                          <Button
                           @click="openModalConfirmationStatus()"
                          :class="locationDetail?.status === 9 ? 'border-blue-500 border-t border-l border-b border-r ':'border'"
                          class="flex font-bold justify-items-start
                           items-center" color="alternative" size="sm" ovariant="outlined">
                             <span class="text-xs"
                             :class="locationDetail?.status === 9 ? 'text-blue-700': 'text-gray-700'"
                             >
                            Set {{ locationDetail?.status === 1 ? 'Inactive' : 'Active' }} Location
                            </span>
                        </Button>
                        <Button @click="openModalDeteleLocation" class="flex border-red-500
                        border-t border-l border-r border-b
                        justify-items-start items-center" ovariant="outlined"
                            color="alternative" size="sm">
                            <span class="text-xs text-red-500">Delete Location</span>
                        </Button>
                    </div>
                </div>
                <div class="grid grid-cols-2 grid-rows-1 gap-4 mt-3">
                    <div class="flex-col">
                        <div>
                            <label class="text-sm text-gray-700 font-semibold">Latitude Longitude</label>
                          <p class="m-0 text-sm text-gray-500">
                            {{ locationDetail?.latitude }},{{ locationDetail?.longitude }} 
                            <span 
                                @click="copyCoordinates" 
                                class="text-blue-500 font-medium text-xs cursor-pointer ml-1 hover:text-blue-700 transition-colors"
                            >
                                {{ isCopied ? 'Copied' : 'Copy' }}
                            </span>
                            </p>
                        </div>
                         <div class="mt-2">
                            <label class="text-sm text-gray-700 font-semibold">Radius</label>
                          <p class="m-0 text-sm text-gray-500">
                              {{ Number(locationDetail?.allowed_radius).toLocaleString('id-ID') }} meters
                            </p>
                        </div>
                         <div class="mt-2">
                            <label class="text-sm text-gray-700 font-semibold">Reading Progress</label>
                          <p class="m-0 text-sm text-gray-500">
                             {{ locationDetail?.reading_progress === 100 ? 'Unlimited' : (locationDetail?.reading_progress || 0) + '%' }}
                               <span 
                                @click="editReadingProgress" 
                                class="text-blue-500 font-medium text-xs cursor-pointer ml-1 hover:text-blue-700 transition-colors"
                            >
                               Edit
                            </span>
                            </p>
                        </div>
                        
                    </div>
                    <div>
                         <div class="mt-0">
                            <label class="text-sm text-gray-700 font-semibold">Terakhir Diubah</label>
                          <p class="m-0 text-sm text-gray-500">
                            {{ formatDate(locationDetail?.modified_at) }}
                            </p>
                        </div>
                         <div class="mt-2">
                            <label class="text-sm text-gray-700 font-semibold">Status</label>
                          <p class="m-0 text-sm text-gray-500">
                                <span v-if="locationDetail?.status === 1" class="p-1 text-green-700 font-normal bg-green-100 rounded-lg text-xs">Live</span>
                                       <span v-else class="p-1 text-gray-700 font-normal bg-gray-100 rounded-lg text-xs">Inactive</span>
                         
                            </p>
                        </div>
                    </div>
                </div>
        </div>
         <div class="bg-white w-4/5  block rounded-lg shadow-sm p-4 justify-center items-center px-3 text-center h-80">
          <div class=" rounded-lg text-center flex justify-center ">
            <img :src="locationDetail?.qr_image" alt="QR Code" class="w-48 border rounded-xl object-contain" />
          </div>
          <div class="flex-col items-center justify-center space-y-3 mt-3">
                <p class="text-sm mb-0 px-3 text-gray-500">Users can only access the SmartPin collection from this area.</p>
            <div class="flex justify-center items-center space-x-4">
                          <Button
                          @click="handleCopyUrl"
                          class="flex border justify-items-start
                           items-center" color="alternative" size="sm" ovariant="outlined">
                             <span class="text-xs text-gray-700"
                             >
                        <i class="fa-solid fa-copy"></i> Copy URL
                            </span>
                        </Button>
                        <Button @click="handleDownloadQR" class="flex border space-x-2
                        justify-center items-start" ovariant="outlined"
                            color="alternative" size="sm">
                            <div class="text-xs text-gray-700 flex justify-center items-center ">
                           <i class="fa-solid fa-download mr-1"></i>
                            Download QR</div>
                        </Button>
                    </div>
          </div>
        
        </div>
    </div>
        <SmartPinDetailContent />
     <t-modal ref="openModalReadingProgress">
      <div class="flex-col justify-center text-left">
        <label class="text-left font-semibold text-sm text-gray-800 tracking-normal">Set Reading Progress Limits</label>
        <p class="text-gray-500 text-xs font-normal">Choose whether users can read without limits or only up to a specified reading progress.</p>
      </div>
      <div>
          
          <label class="flex items-center cursor-pointer">
            <input 
              type="radio" 
              value="none"
               @input="handleRetrictions"
              v-model="limitType"
              class="w-5 h-5 text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer"
            >
            <span class="ml-3 text-gray-700 text-xs font-medium">No restrictions</span>
          </label>

          <label class="flex items-center cursor-pointer">
            <input 
              type="radio" 
              value="limit" 
              v-model="limitType"
              class="w-5 h-5 text-xs text-blue-600 border-gray-300 focus:ring-blue-500 cursor-pointer"
            >
            <div class="ml-3 flex items-center space-x-3 text-gray-900 font-medium">
              <span class="text-gray-700 text-xs">Limit to</span>
              
            <div class="relative flex items-center">
  <input 
    type="number" 
    v-model="progressLimit"
    :disabled="limitType !== 'limit'"
    min="1"
    max="100"
    @input="validateProgressLimit"
    class="w-16 text-xs border border-gray-200 bg-gray-50 rounded-lg py-1.5 pl-2 pr-7 text-center focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent disabled:opacity-50 transition-all"
  >
  <span class="absolute right-3 text-gray-500 font-normal">%</span>
</div>
              
              <span class="text-gray-700 text-xs">Reading Progress</span>
            </div>
          </label>
        </div>
      <div class="flex justify-start items-center space-x-3">
           <Button :class="{ 'opacity-50': !progressLimit }" :disabled="!progressLimit" @click="handleReadingProgress" size="sm">
           <span class="text-xs">
                Save
            </span>
        </Button>
         <Button variant="outlined" @click=" ()=> {
          this.$refs.openModalReadingProgress.hide();
        }"
            color="alternative" size="sm">
            <span class="text-xs">
              Cancel
            </span>
        </Button>
     
      </div>
    </t-modal>
    <t-modal @before-close="onBeforeCloseModalStatus" ref="modalConfirmationStatus">
  <div class="flex-col justify-center text-center p-0">
    <label class="text-center font-semibold text-base text-gray-800 tracking-normal">
     {{locationDetail.status  == 1 ? 'Deactivate' : 'Active'}} Location
    </label>
    <p v-if="locationDetail.status == 9"  class="text-gray-500 text-sm font-normal mt-0">
   Users within this location will be able to access onsite content after this location is activated.
    </p>
     <p v-else-if="locationDetail.status == 1"  class="text-gray-500 text-sm font-normal mt-0">
  Users within this location will no longer be able to access onsite content after this location is deactivated.
    </p>
  </div>
 <div class="flex justify-center items-center space-x-3 mt-4">
    <Button 
      v-if="locationDetail.status == 9" 
      @click="confirmStatusChange" 
      size="sm"
    >
      Activate Location
    </Button>

    <Button 
      v-else-if="locationDetail.status == 1" 
      color="red" 
      class="bg-red-500 text-white"
      variant="default" 
      @click="confirmStatusChange" 
      size="sm"
    >
      Deactivate Location
    </Button>

    <Button 
      @click="cancelStatusChange" 
      variant="outlined" 
      color="alternative" 
      size="sm"
    >
      Cancel
    </Button>

</div>
</t-modal>
<t-modal ref="modalDeleteLocation">
    <div class="flex-col justify-center text-center p-0">
        <div>
            <i class="fa-solid fa-triangle-exclamation text-yellow-500 text-2xl"></i>
        </div>
    <label class="text-center font-semibold text-base text-gray-800 tracking-normal">
    Delete this location permanently?
    </label>
    <p  class="text-gray-500 text-sm font-normal mt-0">
 This action cannot be undone. The geofence tracking will stop immediately, the QR code will become invalid, and all curated content links for this location will be cleared.
    </p>
     <div class="flex justify-center items-center space-x-3 mt-4">
    
    <Button 
      @click="handleDeleteLocation()" 
      size="sm"
      variant="default" 
       color="red" 
      class="bg-red-500 text-white"
      >
    Yes, Delete Location
    </Button>

    <Button 

      @click="()=> {
        this.$refs.modalDeleteLocation.hide();
      }"
      variant="outlined" 
      color="alternative" 
      size="sm"
    >
      Cancel
    </Button>

</div>
  </div>
</t-modal>

  </div>
</template>

<script>
import { mapActions } from 'vuex';
import HeaderBreadcrumbs from '@/components/HeaderBreadcrumbs.vue';
import Button from '@/components/ui/Button'
import SmartPinDetailContent from '../../components/smart-pin/content-book-smart-pin.vue'
import { EventBus } from '../../../src/event-bus';
import moment from 'moment';
export default {
  name: 'DetailLocation',
  components: {
    HeaderBreadcrumbs,
    SmartPinDetailContent,
    Button
  },
  data() {
    return {
      locationDetail: [],
      isLoading: false,
      limitType: 'limit',
      isError: false,
      progressLimit: 25,
      isCopied: false,
      isCopiedQR:false,
    };
  },
  mounted() {
    const locationId = this.$route.params.id; 
    
    if (locationId) {
      this.fetchDetailData(locationId);
    }
  },
  methods: {
    ...mapActions('smartpin', ['getLocationById','updateLocationStatus','deleteLocation']),

    async fetchDetailData(id) {
      this.isLoading = true;
      this.isError = false;
    
      try {
        const response = await this.getLocationById(id);
        this.locationDetail = response.data; 
        this.progressLimit = this.locationDetail.reading_progress
      } catch (error) {
        this.isError = true;
        console.error("Gagal merender detail:", error);
      } finally {
        this.isLoading = false;
      }
    },
    copyCoordinates() {
      const textToCopy = `${this.locationDetail.latitude},${this.locationDetail.longitude}`;
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.isCopied = true;
        setTimeout(() => {
          this.isCopied = false;
        }, 2000);
    EventBus.$emit('show-toast', {
          message: 'Copied URL',
          type: 'success'
        });
      }).catch(err => {
        console.error('Gagal menyalin teks: ', err);
      });
    },
     handleCopyUrl() {
      const textToCopy = `${this.locationDetail.qr_url}`;
      navigator.clipboard.writeText(textToCopy).then(() => {
        this.isCopiedQR = true;
        EventBus.$emit('show-toast', {
          message: 'Copied URL',
          type: 'success'
        });
        

      }).catch(err => {
        console.error('Gagal menyalin teks: ', err);
      });
    },
    formatDate(dateString) {
      if (!dateString) return '-';   
      return moment(dateString).locale('id').format('DD MMMM YYYY, HH:mm:ss');
    },
   validateProgressLimit(event) {
    let rawValue = event.target.value;

    if (rawValue === '') {
      return; 
    }

    let value = parseInt(rawValue);
    
    if (value > 100) {
      this.progressLimit = 100;
    } 
    else if (value < 1) {
      this.progressLimit = 1;
    }
  },
    editReadingProgress() {
      if (this.locationDetail.reading_progress === 100) {
        this.limitType = 'none';
      } else {
        this.limitType = 'limit';
        this.progressLimit = this.locationDetail.reading_progress || 25;
      }
      this.$refs.openModalReadingProgress.show();
    },
    openModalConfirmationStatus() {
          this.$refs.modalConfirmationStatus.show();
    },
   handleReadingProgress() {
  let selectedProgress;

  if (this.limitType === 'none') {
    selectedProgress = 100;
  } else {
    if (this.progressLimit === '' || this.progressLimit === null) {
      selectedProgress = this.locationDetail.reading_progress;
    } else {
      selectedProgress = parseInt(this.progressLimit);
    }
  }

  const payload = {
    id: this.locationDetail.id, 
    status: this.locationDetail.status,
    reading_progress: selectedProgress 
  };

  this.updateLocationStatus(payload).then(() => {
    this.$refs.openModalReadingProgress.hide();
   const locationId = this.$route.params.id; 
    if (locationId) {
      this.fetchDetailData(locationId);
    }
    
  }).catch(() => {
    
  });
},
handleRetrictions() {
        this.progressLimit = this.locationDetail.reading_progress || 25;
    
},
handleDownloadQR() {
        if (!this.locationDetail || !this.locationDetail.qr_image) {
        console.error('Data QR tidak ditemukan');
        return;
      }

      const downloadLink = document.createElement('a');
      
      downloadLink.href = this.locationDetail.qr_image;
      
      const fileName = this.locationDetail.name.replace(/\s+/g, '_')
      downloadLink.download = `QR_${fileName}.png`;
      
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    },
     confirmStatusChange() {
         const payload = {
        id: this.locationDetail.id, 
        status: this.locationDetail.status === 1 ? 9 : 1 ,
        reading_progress: this.progressLimit
        }
          this.updateLocationStatus(payload).then(() => {
          this.$refs.modalConfirmationStatus.hide();
           const locationId = this.$route.params.id; 
          if (locationId) {
            this.fetchDetailData(locationId);
          }
    
    }).catch(() => {
    
    });
  },
   onBeforeCloseModalStatus() {
   
  },
  cancelStatusChange() {
     this.$refs.modalConfirmationStatus.hide();
  },
  openModalDeteleLocation() {
 this.$refs.modalDeleteLocation.show();
  },
  handleDeleteLocation() {
  this.deleteLocation(this.locationDetail.id)
    .then((response) => {
      if (response.status === 200) {
        this.$refs.modalDeleteLocation.hide();
        
        EventBus.$emit('show-toast', {
          message: 'Location access has been deleted.',
          type: 'success'
        });
        
        setTimeout(() => {
          this.$router.push({ name: 'smart-pin' });
        }, 2000);
      } 
    })
    .catch((error) => {
      console.error("Gagal menghapus lokasi:", error);
      EventBus.$emit('show-toast', {
        message: 'Gagal menghapus lokasi.',
        type: 'error'
      });
    });
},
  

  }
}
</script>
<style scoped>
input[type=number]::-webkit-inner-spin-button, 
input[type=number]::-webkit-outer-spin-button { 
  -webkit-appearance: none; 
  margin: 0; 
}
input[type=number] {
  -moz-appearance: textfield;
}
</style>